import { ClientField } from "../fields";
import { LABELS_ABOVE_SCREEN_TYPE_ID } from "../../lib/sheets";
export const ScreenPreview = ({
  entries,
  sheetType = LABELS_ABOVE_SCREEN_TYPE_ID
}) => <div className="section--entries">
    {entries.map((entry, i) => <ClientField entry={entry} key={`preview-field-${entry.guid}-${i}`} rowGuid={entries[0].rowGuid} sheetType={sheetType} />)}
  </div>;